<template>
  <card-item
    card="item_shop"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['shops'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
        {
          title: "Связь с партнером",
          key: "fields",
          component: () => import("./Systems"),
        },
        {
          title: "Ограничения локации",
          key: "permissions",
          component: () => import("./ServicePermissions"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>